import type Swiper from 'swiper';

type SwiperInitialisedElement = HTMLElement & { swiper: Swiper };

document.addEventListener('DOMContentLoaded', () => {
  var classNames = {
    active: 'active',
    matched: 'matched-filter',
    noFilter: 'no-filter',
    noItems: 'no-items',
    oneItem: 'one-item',
    visible: 'visible',
  };

  function applyFilter(category: string) {
    var servicesGrid = document.querySelector('.services-grid') as SwiperInitialisedElement | null;
    if (!servicesGrid) return;

    var serviceItems = servicesGrid.querySelectorAll<HTMLElement>('.service-item');
    serviceItems.forEach((el) => el.classList.remove(classNames.matched));

    servicesGrid.classList.add(classNames.noFilter);
    var wrapper = servicesGrid.querySelector('.swiper-wrapper') as HTMLElement | null;
    if (wrapper) wrapper.classList.add(classNames.noFilter);

    document.querySelectorAll<HTMLElement>('.selected-filter').forEach((el) => {
      el.textContent = category;
    });

    if (category.toLowerCase().indexOf('all treatments') === -1) {
      servicesGrid.classList.remove(classNames.noFilter);
      if (wrapper) wrapper.classList.remove(classNames.noFilter);

      const categoryIndex = category.split(' | ')[0];

      serviceItems.forEach((item) => {
        var itemCategories = item.getAttribute('data-categories')?.split('$$');

        if (itemCategories && !!itemCategories.find((cat) => cat.indexOf(categoryIndex) !== -1)) {
          item.classList.add(classNames.matched);
        }
      });
    }

    var hasNoFilter = !!servicesGrid.querySelector('.' + classNames.noFilter);
    var matchedCount = servicesGrid.querySelectorAll('.service-item.' + classNames.matched).length;

    servicesGrid.classList.toggle(classNames.noItems, !hasNoFilter && matchedCount === 0);

    if (wrapper) {
      wrapper.classList.toggle(classNames.noItems, matchedCount === 0);
      wrapper.classList.toggle(classNames.oneItem, matchedCount === 1);
    }

    servicesGrid.swiper?.update();

    servicesGrid.swiper?.slideTo(0);
  }

  (function () {
    window.Medispa.carousels['treatment-categories'] = new window.Swiper(
      '.filters-wrapper.swiper',
      {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        slidesPerGroupAuto: true,
        spaceBetween: 16,
        navigation: {
          nextEl: '.filters-button.swiper-button-next',
          prevEl: '.filters-button.swiper-button-prev',
        },
      },
    );

    window.Medispa.carousels['services-grid'] = new window.Swiper('.services-grid.swiper', {
      slidesPerView: 1.2,
      slidesPerGroup: 1,
      loop: false,
      spaceBetween: 12,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      pagination: {
        el: '.services-grid .swiper-pagination',
        clickable: true,
      },
      allowSlidePrev: true,
      allowSlideNext: true,
      allowTouchMove: true,
      breakpoints: {
        768: {
          slidesPerView: 2.2,
          spaceBetween: 12,

          allowSlidePrev: true,
          allowSlideNext: true,
          allowTouchMove: true,
        },
        1140: {
          slidesPerView: 'auto',
          slidesPerGroupAuto: true,
          allowTouchMove: false,
          spaceBetween: 0,
          allowSlidePrev: true,
          allowSlideNext: true,
        },
      },
      on: {
        resize: function (swiper: Swiper) {
          swiper.slideTo(0);
          swiper.update();
        },
      },
    });

    document.addEventListener('click', (e) => {
      var target = e.target as Element | null;
      if (!target) return;

      var filterEl = target.closest('[data-action="filter-services"]') as HTMLElement | null;
      if (filterEl) {
        var filterCategory = filterEl.getAttribute('data-filter');
        if (!filterCategory) return;

        document
          .querySelectorAll('[data-action="filter-services"].' + classNames.active)
          .forEach((el) => el.classList.remove(classNames.active));

        filterEl.classList.add(classNames.active);

        applyFilter(filterCategory);

        var mobileVersion = document.querySelector<HTMLInputElement>(
          ".mobile-filters [name='filter-category-mobile'][value='" + filterCategory + "']",
        );

        if (mobileVersion) {
          document
            .querySelectorAll('.mobile-filters .filter__option.' + classNames.active)
            .forEach((el) => el.classList.remove(classNames.active));

          var li = mobileVersion.closest('li.filter__option');
          if (li) li.classList.add(classNames.active);
          mobileVersion.checked = true;
        }

        return;
      }

      var filtersSelect = target.closest('.filters-select') as HTMLElement | null;
      if (filtersSelect) {
        var parent = filtersSelect.parentElement;
        if (parent) {
          Array.from(parent.children).forEach((child) => {
            if (
              child instanceof HTMLElement &&
              (child.matches('.filters__popup-background') || child.matches('.filters__popup'))
            ) {
              child.classList.add(classNames.visible);
            }
          });
        }
        return;
      }

      var popupBg = target.closest(
        '.filters__popup-background.' + classNames.visible,
      ) as HTMLElement | null;
      if (popupBg) {
        document
          .querySelectorAll('.filters__popup-background, .filters__popup')
          .forEach((el) => el.classList.remove(classNames.visible));
        return;
      }
    });

    document.addEventListener('change', (e) => {
      var target = e.target as HTMLInputElement | null;
      if (!target) return;
      if (target.name === 'filter-category-mobile') {
        document
          .querySelectorAll('li.filter__option.' + classNames.active)
          .forEach((el) => el.classList.remove(classNames.active));

        var wrapper = target.closest('li.filter__option');
        if (!wrapper) return;
        wrapper.classList.add(classNames.active);
      }
    });

    document.addEventListener('click', (e) => {
      var target = e.target as Element | null;
      if (!target) return;

      var applyCta = target.closest('.filter__apply-cta');
      if (applyCta) {
        var checked = document.querySelector<HTMLInputElement>(
          "[name='filter-category-mobile']:checked",
        );
        var filterCategory = checked?.getAttribute('data-filter')?.split(' | ')[1];
        if (!filterCategory) return;

        applyFilter(filterCategory);

        var desktopVersion = document.querySelector<HTMLElement>(
          ".desktop-filters .category-pill[data-filter='" + filterCategory + "']",
        );

        if (desktopVersion) {
          document
            .querySelectorAll('.desktop-filters .category-pill.' + classNames.active)
            .forEach((el) => el.classList.remove(classNames.active));
          desktopVersion.classList.add(classNames.active);
        }

        document
          .querySelectorAll('.filters__popup-background, .filters__popup')
          .forEach((el) => el.classList.remove(classNames.visible));
      }
    });
  })();
});
